module.exports = "\n<div class=\"comp-countries-map\" style=\"overflow:hidden;\">\n  <map-canvas :active-country-codes=\"activeCountryCodesArray\" v-on:countryClick=\"onMapCountryClicked\" :zoom=\"mapZoom\" :default-center=\"defaultCenterLatLng\" :interactive=\"isInteractive\"></map-canvas>\n  <div class=\"comp-countries-map-inner-shadow\"></div>\n  <div class=\"comp-countries-map-inner-shadow\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./assets/js/frontend/components/countries_map/index.pug
// module id = 678
// module chunks = 4